import React, { Component } from 'react'
import { connect } from 'react-redux'
import IndRefundWithVaultSample from '../samples/IndRefundWithVaultSample'
import { updateOrderId } from '../../../actions/commonActions'
import { makeIndRefundWithVault } from '../../../actions/mcpActions'
import { _MCP, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    data_key: ["mcpResIndRefundCC.SetData(data_key);", "mcpResIndRefundCC.setData(data_key);", "'data_key'=>$data_key"],
    order_ID: ["mcpResIndRefundCC.SetOrderId(order_id);", "mcpResIndRefundCC.setOrderId(order_id);", "'order_id'=>$order_id"],
    electronic_commerce_indicator: ["mcpResIndRefundCC.SetCryptType(crypt);", "mcpResIndRefundCC.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    version_number: ["mcpResIndRefundCC.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpResIndRefundCC.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpResIndRefundCC.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpResIndRefundCC.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpResIndRefundCC.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpResIndRefundCC.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    customer_ID: ["mcpResIndRefundCC.SetCustId(cust_id);", "mcpResIndRefundCC.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    
    rate_token: ["mcpResIndRefundCC.SetMCPRateToken(\"MCP_RATE_TOKEN\");", "mcpResIndRefundCC.setMCPRateToken(\"MCP_RATE_TOKEN\");", "'mcp_rate_token' => $mcp_rate_token"],
}


export class IndRefundWithVault extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakeIndRefundWithVaultPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _MCP, orderId: newOrderId });
        const { storeId, apiToken, expdate, amount, currency, mcpRateToken } = this.props;
        const indRefundWithVaultRequest = { storeId, apiToken, orderId: newOrderId, expdate, amount, currency, mcpRateToken };
        this.props.makeIndRefundWithVault(indRefundWithVaultRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample MCP Independent Refund with Vault</h3>
                <IndRefundWithVaultSample />
                <div className="requestButton" onClick={() => this.onMakeIndRefundWithVaultPress()}>
                    MCP Independent Refund with Vault Request
                </div> 
            </div>
        )
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Independent Refund with Vault</b></span>
                <p style={{marginTop: '3vh'}}>This transaction uses the data key to identify a previously registered credit card profile in Vault. The details saved within the profile are then submitted to perform an Independent Refund transaction.</p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>

                <div className="thingsToConsider">
                    <h3>Things to Consider: </h3>
                    <ul>
                        <li>Because of the potential for fraud, permission for this transaction is not granted to all accounts by default. If it is required for your business, it must be requested via your account manager.</li>
                    </ul>
                </div>

                <p><b>MCP Independent Refund with Vault transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>MCPResIndRefundCC mcpResIndRefundCC = new MCPResIndRefundCC();</code>
                    case _JAVA:
                        return <code>MCPResIndRefundCC mcpResIndRefundCC = new MCPResIndRefundCC();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_res_ind_refund_cc', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Independent Refund with Vault transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpResIndRefundCC);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpResIndRefundCC);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Independent Refund with Vault transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>data key</td>
                        <td><i>String</i><br /><br />25-character alphanumeri</td>
                        <td><code>{CODES.data_key[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Independent Refund with Vault transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP rate token</td>
                        <td><i>String</i><br /><br />N/A</td>
                        <td><code>{CODES.rate_token[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, expdate, amount, currency, mcpRateToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, expdate, amount, currency, mcpRateToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeIndRefundWithVault, updateOrderId})(IndRefundWithVault)
